export default __webpack_public_path__ + "assets/png/44c7c936d5ecdf5580a9b10773c97556.png";